import React, { FC } from 'react';
import { ICONS_HEIGHT, STATIC_IMAGE_URLS } from 'modules/core/constants';

import { CalendarIcon } from './styles';

export const CalendarAdornment: FC = () => (
  <CalendarIcon src={STATIC_IMAGE_URLS.icons.calendar} height={ICONS_HEIGHT.EXTRA_SMALL} />
);
